import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from './getters';

const state = {
  id: null,
  companyName: null,
  email: null,
  firstName: null,
  lastName: null,
  addressLine1: null,
  addressLine2: null,
  townCity: null,
  postcode: null,
  countryId: null,
  companyRegistrationNumber: null,
  contactName: null,
  contactEmail: null,
  invoicingId: null,
  features: [],
  shareeCount: 0,
  properties: [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
